export default class Rest {
    constructor(Restangular, TokenHandler) {
        this.rest = Restangular;
        var token = 'Bearer ' + TokenHandler.getToken();
        this.rest.setDefaultHeaders({'Authorization': token});
    }
}

Rest.$inject = ['Restangular', 'TokenHandler'];
